import { CakeIcon } from 'lucide-react'

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'

export function BirthdayIcon({ visible }: { visible?: boolean }) {
  if (!visible) return null

  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            tabIndex={0}
            role="img"
            aria-label="Geburtstag am Kurstag"
            className="ml-1.5 inline-flex shrink-0 align-middle text-primary"
          >
            <CakeIcon aria-hidden="true" className="h-4 w-4" />
          </span>
        </TooltipTrigger>
        <TooltipContent>Geburtstag am Kurstag</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
